// extracted by mini-css-extract-plugin
module.exports = {"empty_section":"SuccessWidget_empty_section__2NyRX"};